module.exports = __webpack_public_path__ + "fonts/Raleway-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Raleway/Raleway-Regular.ttf
// module id = 3454
// module chunks = 0